import { BookingTemplateTypes } from "@assets/types";

//-- Used as a helper to get a more readable Partner from the return object from AuthAPI
export const partnerAddressToPartner = (
  partnerAddress: BookingTemplateTypes.PartnerAddress
): BookingTemplateTypes.Partner => {
  return {
    PartnerCode: partnerAddress.PartnerCode,
    AddressType: partnerAddress.AddressType,
    CompanyName: partnerAddress.FullName,
    StreetAndNumber: partnerAddress.Address1,
    City: partnerAddress.Address2,
    PostalCode: partnerAddress.PostCode,
    County: partnerAddress.Address3,
    Country: partnerAddress.Address4,
    AdditionalAddressInfo: "",
    ContactName: partnerAddress.ContactName,
    Email: partnerAddress.ContactEmail,
    Phone: partnerAddress.ContactNumber,
    PointCode: partnerAddress.PointCode,
  };
};
